import axios from "axios";
import { toast } from "react-hot-toast";

/* ================================
   ACTION TYPES
================================ */

export const FETCH_DISTRICTS_REQUEST = "FETCH_DISTRICTS_REQUEST";
export const FETCH_DISTRICTS_SUCCESS = "FETCH_DISTRICTS_SUCCESS";
export const FETCH_DISTRICTS_FAILURE = "FETCH_DISTRICTS_FAILURE";

export const FETCH_MUNICIPALITIES_REQUEST = "FETCH_MUNICIPALITIES_REQUEST";
export const FETCH_MUNICIPALITIES_SUCCESS = "FETCH_MUNICIPALITIES_SUCCESS";
export const FETCH_MUNICIPALITIES_FAILURE = "FETCH_MUNICIPALITIES_FAILURE";

export const FETCH_WARDS_REQUEST = "FETCH_WARDS_REQUEST";
export const FETCH_WARDS_SUCCESS = "FETCH_WARDS_SUCCESS";
export const FETCH_WARDS_FAILURE = "FETCH_WARDS_FAILURE";

export const FETCH_CANTEEN_TYPES_REQUEST = "FETCH_CANTEEN_TYPES_REQUEST";
export const FETCH_CANTEEN_TYPES_SUCCESS = "FETCH_CANTEEN_TYPES_SUCCESS";
export const FETCH_CANTEEN_TYPES_FAILURE = "FETCH_CANTEEN_TYPES_FAILURE";

export const FETCH_CANTEEN_LIST_REQUEST = "FETCH_CANTEEN_LIST_REQUEST";
export const FETCH_CANTEEN_LIST_SUCCESS = "FETCH_CANTEEN_LIST_SUCCESS";
export const FETCH_CANTEEN_LIST_FAILURE = "FETCH_CANTEEN_LIST_FAILURE";

/* ================================
   BASE API URL (from .env)
================================ */
const BASE_URL = process.env.REACT_APP_API_BASE_URL;


/* ================================
   COMMON AUTH HEADER
================================ */
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};


/* ================================
   FETCH DISTRICTS
================================ */
export const fetchDistricts = () => async (dispatch) => {
  dispatch({ type: FETCH_DISTRICTS_REQUEST });

  try {
    const res = await axios.get(`${BASE_URL}/api/districts`, {
      headers: getAuthHeader(),
    });

    dispatch({
      type: FETCH_DISTRICTS_SUCCESS,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_DISTRICTS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    toast.error("Failed to fetch districts");
  }
};
/* ================================
   FETCH MUNICIPALITIES (by district)
================================ */
export const fetchMunicipalities = (districtId) => async (dispatch) => {
  dispatch({ type: FETCH_MUNICIPALITIES_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/municipalities?district_id=${districtId}`,
      {
        headers: getAuthHeader(),
      }
    );

    dispatch({
      type: FETCH_MUNICIPALITIES_SUCCESS,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_MUNICIPALITIES_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    toast.error("Failed to fetch municipalities");
  }
};


/* ================================
   FETCH WARDS (by municipality)
================================ */
export const fetchWards = (municipalityId) => async (dispatch) => {
  dispatch({ type: FETCH_WARDS_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/wards?municipality_id=${municipalityId}`,
      {
        headers: getAuthHeader(),
      }
    );

    dispatch({
      type: FETCH_WARDS_SUCCESS,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_WARDS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    toast.error("Failed to fetch wards");
  }
};


/* ================================
   FETCH CANTEEN TYPES
================================ */
export const fetchCanteenTypes = () => async (dispatch) => {
  dispatch({ type: FETCH_CANTEEN_TYPES_REQUEST });

  try {
    const res = await axios.get(`${BASE_URL}/api/maa_canteen/type`);

    dispatch({
      type: FETCH_CANTEEN_TYPES_SUCCESS,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CANTEEN_TYPES_FAILURE,
      payload: error.message,
    });
    toast.error("Failed to fetch canteen types");
  }
};

/* ================================
   FETCH CANTEEN LIST (FILTERED)
================================ */
export const fetchCanteenList =
  ({ district_id, municipality_id, ward_id, canteen_type }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CANTEEN_LIST_REQUEST });

    try {
      const res = await axios.get(`${BASE_URL}/api/maa_canteen/canteenList`, {
        // Axios params automatically builds query string
        params: {
          district_id,
          municipality_id,
          ward_id,
          canteen_type,
        },
      });

      dispatch({
        type: FETCH_CANTEEN_LIST_SUCCESS,
        payload: res.data.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_CANTEEN_LIST_FAILURE,
        payload: error.message,
      });
      toast.error("Failed to fetch canteen list");
    }
  };
